import React from 'react';
import { FormCheckbox } from 'shards-react';
import SendMailTip from './SendMailTip';
import { useTranslation } from 'react-i18next';

interface SwitchNotificationProps {
  notificationFlag: boolean;
  // onSwitchNotification: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSwitchNotification: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const SwitchNotification = React.memo(({ notificationFlag, onSwitchNotification }: SwitchNotificationProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <div className="d-inline-block" onClick={onSwitchNotification}>
        {/* <FormCheckbox className="d-inline-block" toggle small checked={notificationFlag} onChange={onSwitchNotification}> */}
        <FormCheckbox className="d-inline-block" toggle small checked={notificationFlag}>
          {notificationFlag ? t('user.emailTurnOn') : t('user.emailTurnOff')}
          <SendMailTip />
        </FormCheckbox>
      </div>
    </>
  );
});

SwitchNotification.displayName = 'SwitchNotification';
export default SwitchNotification;
